export { default } from './EntityLabel';
